var map = {
	"./dollar.svg": [
		6469,
		469
	],
	"./hammer.svg": [
		81,
		81
	],
	"./human.svg": [
		3558,
		558
	],
	"./kebab.svg": [
		3926,
		926
	],
	"./lynch.svg": [
		6598,
		598
	],
	"./paper.svg": [
		842,
		47
	],
	"./plus.svg": [
		3165,
		165
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9244;
module.exports = webpackAsyncContext;